import { render, staticRenderFns } from "./SelectBoxTextForm.vue?vue&type=template&id=6d6d88e0&scoped=true&"
import script from "./SelectBoxTextForm.vue?vue&type=script&lang=js&"
export * from "./SelectBoxTextForm.vue?vue&type=script&lang=js&"
import style0 from "./SelectBoxTextForm.vue?vue&type=style&index=0&id=6d6d88e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6d88e0",
  null
  
)

export default component.exports